import { Megaphone, ArrowRight } from "lucide-react";

interface ChangelogItem {
  date: string;
  title: string;
  description: string;
  tag: "new" | "improved" | "fix";
}

const changelog: ChangelogItem[] = [
  {
    date: "Mar 2026",
    title: "Launch Advisor — 7-Day Visual Timeline",
    description: "Get a personalised, platform-specific 7-day launch plan with daily checklists and post-launch strategy.",
    tag: "new",
  },
  {
    date: "Mar 2026",
    title: "AskFint — Context-Aware AI Mentor",
    description: "AskFint now knows your scripts, products, and keywords to give truly personalised advice.",
    tag: "improved",
  },
  {
    date: "Mar 2026",
    title: "Keyword Research — Improved Reliability",
    description: "Added retry logic and better error handling for more consistent search results.",
    tag: "fix",
  },
];

const tagStyles: Record<string, string> = {
  new: "bg-green-500/20 text-green-400",
  improved: "bg-blue-500/20 text-blue-400",
  fix: "bg-amber-500/20 text-amber-400",
};

export function WhatsNew() {
  return (
    <div className="glass-card p-6">
      <div className="flex items-center gap-2 mb-4">
        <Megaphone className="w-5 h-5 text-primary" />
        <h2 className="font-display text-xl font-semibold">What's New</h2>
      </div>
      <div className="space-y-3">
        {changelog.map((item, i) => (
          <div key={i} className="flex gap-3 p-3 rounded-lg bg-muted/30">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className={`text-[10px] font-semibold uppercase px-2 py-0.5 rounded-full ${tagStyles[item.tag]}`}>
                  {item.tag}
                </span>
                <span className="text-xs text-muted-foreground">{item.date}</span>
              </div>
              <p className="text-sm font-medium text-foreground">{item.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
